import React, { useState, useEffect } from 'react';
import { Modal, Button, Descriptions, Table } from 'antd';
import { NotificationManager } from 'react-notifications';
import { customBaseUrl, httpGet } from '../../../store/http';
import { hideLoader, showLoader } from '../../../utils/loader';

const LoanHistoryModal = ({ showModal, hideModal, loanId }) => {
  const [loanHistoryData, setLoanHistoryData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLoanHistory = async () => {
      if (!loanId) return;
      setLoading(true);
      showLoader();
      try {
        const token = localStorage.getItem('loanAdminToken');
        if (!token) {
          window.location.href = '/loan-admin-login';
          return;
        }
        const res = await httpGet(
          `${customBaseUrl.loanUrl}/api/v1/admin/loan-credit-history/${loanId}`,
          null,
          false,
          false,
          token
        );
        if (res.status) {
          setLoanHistoryData(res.data);
        } else {
          NotificationManager.error(res.message || 'Failed to fetch loan history');
        }
      } catch (error) {
        console.error('Error fetching loan history:', error);
        NotificationManager.error('Error fetching loan history');
      } finally {
        setLoading(false);
        hideLoader();
      }
    };

    if (showModal) {
      fetchLoanHistory();
    }
  }, [showModal, loanId]);

  const creditHistoryColumns = [
    { title: 'Provider', dataIndex: 'provider', key: 'provider' },
    { title: 'Loan Type', dataIndex: 'loan_type', key: 'loan_type' },
    { title: 'Amount', dataIndex: 'amount', key: 'amount' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    { title: 'Disbursement Date', dataIndex: 'disbursement_date', key: 'disbursement_date' },
    { title: 'Last Payment Date', dataIndex: 'last_payment_date', key: 'last_payment_date' },
  ];

  return (
    <Modal
      title="Loan History"
      visible={showModal}
      onCancel={hideModal}
      footer={null}
      width={800}
    >
      {loading ? (
        <div>Loading loan history...</div>
      ) : loanHistoryData ? (
        <>
          <h3>Profile</h3>
          <Descriptions bordered column={1}>
            <Descriptions.Item label="Full Name">{loanHistoryData.data.profile.full_name}</Descriptions.Item>
            <Descriptions.Item label="Date of Birth">{loanHistoryData.data.profile.date_of_birth}</Descriptions.Item>
            <Descriptions.Item label="Gender">{loanHistoryData.data.profile.gender}</Descriptions.Item>
            <Descriptions.Item label="Email Address">{loanHistoryData.data.profile.email_address.join(', ')}</Descriptions.Item>
            <Descriptions.Item label="Phone Number">{loanHistoryData.data.profile.phone_number.join(', ')}</Descriptions.Item>
            <Descriptions.Item label="Identifications">
              {loanHistoryData.data.profile.identifications.map((id, index) => (
                <div key={index}>{id.type}: {id.no}</div>
              ))}
            </Descriptions.Item>
            <Descriptions.Item label="Address History">
              {loanHistoryData.data.profile.address_history.map((address, index) => (
                <div key={index}>{address.type}: {address.address} (Reported: {address.date_reported})</div>
              ))}
            </Descriptions.Item>
          </Descriptions>

          <h3 style={{ marginTop: 20 }}>Credit History</h3>
          {loanHistoryData.data.credit_history && loanHistoryData.data.credit_history.length > 0 ? (
            <Table
              dataSource={loanHistoryData.data.credit_history}
              columns={creditHistoryColumns}
              pagination={false}
              bordered
            />
          ) : (
            <p>No credit history available.</p>
          )}
        </>
      ) : (
        <p>No loan history data available.</p>
      )}
    </Modal>
  );
};

export default LoanHistoryModal;
